import { render, staticRenderFns } from "./ExpirationReminder.vue?vue&type=template&id=3dc2d3c4"
import script from "./ExpirationReminder.vue?vue&type=script&lang=js"
export * from "./ExpirationReminder.vue?vue&type=script&lang=js"
import style0 from "./ExpirationReminder.vue?vue&type=style&index=0&id=3dc2d3c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports